/**
 * Context information to be included with logs
 */
export interface LogContext {
  userId?: string;
  workspaceId?: string;
  workspaceSlug?: string;
  sessionId?: string;
  [key: string]: any;
}

/**
 * Log severity levels
 */
export enum LogLevel {
  DEBUG = "debug",
  INFO = "info",
  WARN = "warn",
  ERROR = "error",
}

/**
 * Log categories for better organization
 */
export enum LogCategory {
  // Authentication & Authorization
  AUTH = "authentication",
  AUTH_LOGIN = "authentication.login",
  AUTH_CALLBACK = "authentication.callback",
  AUTH_SESSION = "authentication.session",
  AUTH_TOKEN = "authentication.token",
  AUTH_ONBOARDING = "authentication.onboarding",

  // API Integration
  API = "api",
  API_REQUEST = "api.request",
  API_RESPONSE = "api.response",
  API_ERROR = "api.error",

  // Database & Sync
  DATABASE = "database",
  DATABASE_INIT = "database.init",
  SYNC = "sync",
  SYNC_PULL = "sync.pull",
  SYNC_PUSH = "sync.push",
  SYNC_CONFLICT = "sync.conflict",
  WEBSOCKET = "websocket",

  // User Actions
  TASK = "task",
  TASK_CREATE = "task.create",
  TASK_UPDATE = "task.update",
  TASK_DELETE = "task.delete",
  ATTACHMENT = "attachment",
  ATTACHMENT_UPLOAD = "attachment.upload",
  REMINDER = "reminder",
  COMMENT = "comment",

  // Subscription & Billing
  SUBSCRIPTION = "subscription",
  SUBSCRIPTION_TRIAL = "subscription.trial",
  SUBSCRIPTION_CHECKOUT = "subscription.checkout",
  SUBSCRIPTION_UPGRADE = "subscription.upgrade",

  // Errors & Performance
  ERROR = "error",
  ERROR_COMPONENT = "error.component_crash",
  ERROR_UNHANDLED = "error.unhandled_rejection",
  PERFORMANCE = "performance",
  PERFORMANCE_WEB_VITALS = "performance.web_vitals",
  PERFORMANCE_ROUTE = "performance.route",

  // Notifications
  NOTIFICATION = "notification",
  NOTIFICATION_REMINDER = "notification.reminder",
  NOTIFICATION_BROWSER = "notification.browser",

  // Navigation
  ROUTE = "route",
  ROUTE_LOAD = "route.load",
  ROUTE_NAVIGATE = "route.navigate",

  // State Management
  STATE = "state",
  STATE_STORE = "state.store",
  STATE_CONTEXT = "state.context",
}

/**
 * Performance metric types
 */
export interface PerformanceMetric {
  name: string;
  duration: number;
  timestamp: number;
  metadata?: Record<string, any>;
}

/**
 * Error information structure
 */
export interface ErrorInfo {
  message: string;
  stack?: string;
  code?: string;
  statusCode?: number;
  component?: string;
  metadata?: Record<string, any>;
}
